"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _LineChart = _interopRequireDefault(require("@/components/Charts/LineChart"));

var _lang = _interopRequireDefault(require("@/lang"));

var _vuex = require("vuex");

var _elementUi = require("element-ui");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: 'statisticalOrgcode:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    lineChart: _LineChart.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      rerender: false,
      labelInChart: [],
      dataForChart: [],
      dataCollection: null,
      tableKey: 0,
      list: null,
      total: 0,
      chartLoading: true,
      listLoading: true,
      time: null,
      organizationOption: [],
      statisticalText: null,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        orgCode: '',
        moneyTypeTo: "",
        timeList: [new Date(Date.now()), new Date(Date.now())],
        statisticalStartTime: '',
        statisticalEndTime: ''
      },
      viewSummary: false,
      summaryList: [] // Append Summary Row (DO NOT DELETE !!!)
      // summaryData: [],
      // summaryAppendData: {},
      // summaryAppended: false

    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['moneyTypeFromOption'])),
  created: function created() {
    this.getOption();
    this.setDefaultTime();
    this.getChart();
    this.chooseListByUser();
    this.fillData();
  },
  mounted: function mounted() {
    this.fillData();
  },
  // Append Summary Row (DO NOT DELETE !!!)
  // computed: {
  //   locale() {
  //     return i18n.locale
  //   }
  // },
  // watch: {
  //   locale: function(locale) {
  //     this.updateSummary()
  //   }
  // },
  methods: {
    chooseListByUser: function chooseListByUser() {
      // if(this.$store.getters.isAdmin || this.$store.getters.isAgent){
      this.getList(); // }
      // if(this.$store.getters.isMerchant){
      //   this.getListInMerchant()
      // }
    },
    convert: function convert() {},
    fillData: function fillData() {
      this.dataCollection = {
        labels: this.labelInChart,
        datasets: [{
          label: _lang.default.t('SMS.sixDayDataForApi'),
          data: this.dataForChart
        }]
      };
    },
    setDefaultTime: function setDefaultTime() {
      var date = new Date(),
          y = date.getFullYear(),
          m = date.getMonth(),
          d = date.getDate();
      var startTime = new Date(y, m, d - 1);
      var endTime = new Date(y, m, d - 1);
      startTime.setHours(0, 0, 0, 0);
      endTime.setHours(23, 59, 59, 0);
      this.listQuery.timeList = [this.dateFormat(startTime), this.dateFormat(endTime)];
    },
    handleExportReport: function handleExportReport() {
      var _this = this;

      var excelName = _lang.default.t("message.statisticalOrgExcel");

      var params = this.getQueryParams();

      _httpUtils.default.post("statisticalOrgcode", "excel", null, params);

      _elementUi.MessageBox.confirm(_lang.default.t("warningMessage.pleaseWaitForExportAndNavigateMessage"), _lang.default.t("warningMessage.pleaseWaitForExportAndNavigateTitle"), {
        confirmButtonText: _lang.default.t("warningMessage.exportAndNavigateConfirmButtonText"),
        cancelButtonText: _lang.default.t("warningMessage.exportAndNavigateCancelButtonText"),
        type: 'warning'
      }).then(function () {
        // route to exported excel page
        _this.$router.push({
          name: "exportedExcel:view"
        });
      }).catch(function () {
        return null;
      });
    },
    getQueryParams: function getQueryParams() {
      if (this.listQuery.timeList == '') {
        return {
          orgCode: this.listQuery.organizationName
        };
      } else {
        return {
          orgCode: this.listQuery.orgCode,
          statisticalStartTime: this.listQuery.timeList[0],
          statisticalEndTime: this.listQuery.timeList[1],
          moneyTypeTo: this.listQuery.moneyTypeTo
        };
      }
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined || date == '-') {
        return "-";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getOption: function getOption() {
      var _this2 = this;

      _httpUtils.default.post("organization", "getOrgs", null, null).then(function (organization) {
        _this2.organizationOption = organization.data;
      }).catch(function (err) {
        _this2.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getChart: function getChart() {
      var _this3 = this;

      if (this.$store.getters.isAgent) {
        return;
      }

      _httpUtils.default.post("statisticalOrgcode", "getOrganizationChart", null, null).then(function (res) {
        _this3.labelInChart = res.data.keys;
        _this3.dataForChart = res.data.values;
        _this3.chartLoading = false;

        _this3.fillData();

        _this3.$nextTick(function () {
          _this3.$refs.lineChart.initChart();
        });
      }).catch(function (err) {
        _this3.$message({
          type: 'error',
          message: err.message
        });
      });
    },
    getList: function getList() {
      var _this4 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ; // Reset Summary (including change page)

      this.viewSummary = false;
      this.summaryList = [];
      this.listLoading = true;
      this.listQuery.statisticalStartTime = this.listQuery.timeList[0];
      this.listQuery.statisticalEndTime = this.listQuery.timeList[1];

      _httpUtils.default.post("statisticalOrgcode", "list", null, this.listQuery).then(function (res) {
        _this4.list = res.data.rows;
        _this4.total = res.data.total; // this.getChartData(this.list);

        setTimeout(function () {
          _this4.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this4.$message({
          type: 'error',
          message: err.message
        });
      }); // Append Summary Row (DO NOT DELETE !!!)
      // .finally(() => {
      //     if (this.summaryAppended === true) {
      //       this.list.push(this.summaryAppendData)
      //     }
      //   })

    },
    getListInMerchant: function getListInMerchant() {
      var _this5 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true;
      this.listQuery.statisticalStartTime = this.listQuery.timeList[0];
      this.listQuery.statisticalEndTime = this.listQuery.timeList[1];

      _httpUtils.default.post("statisticalOrgcodeInMerchant", "list", null, this.listQuery).then(function (res) {
        _this5.list = res.data.rows;
        _this5.total = res.data.total; // this.getChartData(this.list);

        setTimeout(function () {
          _this5.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this5.$message({
          type: 'error',
          message: err.message
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.chooseListByUser();
      this.getChart(); // Reset Summary only when filter change
      // this.viewSummary = false;
      // this.summaryList = [];
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getStatistic: function getStatistic() {
      var _this6 = this;

      this.listQuery.statisticalStartTime = this.listQuery.timeList[0];
      this.listQuery.statisticalEndTime = this.listQuery.timeList[1]; // Append Summary Row (DO NOT DELETE !!!)
      // this.appendSummary();

      var dollarSign;

      if (this.$store.getters.isInternational) {
        dollarSign = "USD" + this.$USDIcon;
      } else {
        dollarSign = "RMB" + this.$RMBIcon;
      }

      _httpUtils.default.post("statisticalOrgcode", "sum", null, this.listQuery).then(function (res) {
        var data = res.data;
        _this6.summaryList = [[{
          label: 'SMS.totalText',
          value: data.totalCount || 0,
          unit: 'SMS.tiao'
        }], [{
          label: "SMS.orderCreateFailCount",
          value: data.orderCreateFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.orderCreateSuccessCount",
          value: data.orderCreateSuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelSubmitFailCount",
          value: data.channelSubmitFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelSubmitSuccessCount",
          value: data.channelSubmitSuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelNotifyFailCount",
          value: data.channelNotifyFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelNotifySuccessCount",
          value: data.channelNotifySuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.depositedCount",
          value: data.depositedCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.refundCount",
          value: data.refundCount || 0,
          unit: 'SMS.tiao'
        }]];

        if (_this6.$store.getters.isAdmin) {
          _this6.summaryList.push([{
            label: "SMS.amountOfConsumption",
            value: data.processConsumeAmount,
            unit: 'USD'
          }, {
            label: "SMS.channelCost",
            value: data.processChannelCostAmount,
            unit: 'USD'
          }, {
            label: "SMS.agencyProfit",
            value: data.processAgentIncomeAmount,
            unit: 'USD'
          }, {
            label: "SMS.profit",
            value: data.processIncomeAmount,
            unit: 'USD'
          }]);
        }

        if (_this6.$store.getters.isAgent) {
          _this6.summaryList.push([{
            label: "SMS.agencyProfit",
            value: data.processAgentIncomeAmount,
            unit: 'USD'
          }, {
            label: "SMS.amountOfConsumption",
            value: data.processConsumeAmount,
            unit: 'USD'
          }]);
        } // this.statisticalText = string.replace(/null/g,'0')

      }).catch(function (err) {
        _this6.$notify({
          title: _this6.$t("common.error"),
          message: _this6.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        _this6.viewSummary = true;
      });
    }
  }
};
exports.default = _default;